import { Combobox as box } from "@headlessui/react";

export const Combobox = box;
